import { gql } from '@apollo/client';

export const RESEND_CONFIRMATION_EMAIL = gql`
  mutation RESEND_CONFIRMATION_EMAIL($appointmentId: String!, $locale: String!) {
    resendConfirmationEmail(appointmentId: $appointmentId, locale: $locale)
  }
`;
